export default __webpack_public_path__ + "static/media/575.f8e364b2.gif";